import { createSelector } from '@reduxjs/toolkit';

import { selectDispatchQueryArgs } from './selectDispatchQueryArgs';

/**
 * The board filters a delta-answering mutation must carry: the delta is merged
 * straight into the cached dispatch data, so it has to be cut with the same
 * filters that data was — otherwise a crew or trip the filters hid gets merged
 * back in. Spread rather than listed out: a filter added to the board query
 * has to reach the delta too, and naming them individually is what let the
 * unassigned panel's filters go missing. Ordering is the one arg the delta has
 * no use for.
 */
export const selectDispatchDeltaFilters = createSelector(
  [selectDispatchQueryArgs],
  ({ unassignedOrdering: _ordering, ...filters }) => filters
);
